<template>
  <v-container>
    <v-row v-if="isDesktop">
      <v-col cols="12">
        <section class="home-hero" :class="{ 'home-hero--mobile': !isDesktop }">
          <div class="home-hero__title">Aktuelle WaizmannTabellen für Ihre Praxis anfordern</div>
          <div class="home-hero__subtitle">Seit 1995 nutzen mittlerweile mehr als 15.000 Zahnärzte in Deutschland die WaizmannTabellen in ihrer Praxis.</div>
          <div class="home-hero__body" :class="{ 'home-hero__body--stack': !isDesktop }">
            <div class="home-hero__tiles">
              <div
                v-for="tile in waizmannTableTiles"
                :key="tile.number"
                class="home-hero__tile"
                :class="tile.colorClass"
              >
                <div class="home-hero__tile-title">
                  {{ tile.title }}<br />{{ tile.subtitle }}
                </div>
                <div class="home-hero__tile-sub">{{ tile.number }}</div>
              </div>
            </div>
            <div v-if="wall5ImageSrc" class="home-hero__media">
              <img
                :src="wall5ImageSrc"
                alt="WaizmannTabelle im Praxiseinsatz"
                class="home-hero__image"
              />
            </div>
          </div>
        </section>
      </v-col>
    </v-row>

    <v-row style="border-bottom: 4px solid #E5EDF4;" class="pr-4 pt-6" v-if="!userData">
      <v-col cols="12">
        <RegisterView newRoute="/waizmanntabellen_bestellen" class="mb-4" />
      </v-col>
    </v-row>
  

<v-row>
  <v-col cols="12">
  <RowBestellung class="my-8" />
  </v-col>

  </v-row>
  <div style="border-top: 4px solid #E5EDF4;"></div>
  <section class="home-next-webinar my-8">
    <div class="home-next-webinar__head">
      <h2 class="home-next-webinar__title">Nächste Webinare</h2>
    </div>

    <div v-if="upcomingWebinarGroups.length > 0" class="home-next-webinar__list">
      <article
        v-for="group in upcomingWebinarGroups"
        :key="group.webinarId"
        class="home-next-webinar__item"
      >
        <div class="home-next-webinar__item-head">
          <router-link class="home-next-webinar__link" :to="`/webinar/${group.webinarId}`">
            Alle Infos anzeigen
          </router-link>
        </div>

        <div class="home-next-webinar__preview">
          <img
            v-if="group.dozentImage"
            :src="group.dozentImage"
            alt="Dozent"
            class="home-next-webinar__photo"
          />
          <div class="home-next-webinar__content">
            <p class="home-next-webinar__eyebrow">Webinar-Voransicht</p>
            <h3 class="home-next-webinar__webinar-title">{{ group.preview.title }}</h3>
            <p v-if="group.preview.webi_dozent" class="home-next-webinar__dozent">
              {{ group.preview.webi_dozent }}
            </p>
            <p v-if="group.dozentDesc" class="home-next-webinar__desc">
              {{ group.dozentDesc }}
            </p>
          </div>
        </div>

        <div class="home-next-webinar__termine">
          <h4 class="home-next-webinar__termine-title">Termine</h4>
          <ul class="home-next-webinar__termine-list">
            <li v-for="webinar in group.terms" :key="webinar.wter_id">
              <span>{{ webinar.beginn }}</span>
              <span class="home-next-webinar__status"> · {{ webinar.statusText }}</span>
            </li>
          </ul>
          <v-btn
            class="home-next-webinar__cta mt-3"
            color="primary"
            :to="`/webinar/${group.webinarId}`"
          >
            jetzt kostenlos an Webinar teilnehmen
          </v-btn>
        </div>
      </article>
    </div>
    <p v-else class="home-next-webinar__empty">
      Aktuell sind keine Webinar-Termine verfügbar.
    </p>
  </section>
  <div style="border-top: 4px solid #E5EDF4;"></div>
  <RowPraxiswissen class="my-8" />
  <div style="border-top: 4px solid #E5EDF4;"></div>

  <RowWebinar class="my-8" />
    <v-row>
      <v-col cols="12">
        <masonry-wall :items="content" :ssr-columns="1" :column-width="320" :gap="16" >
                    <template  #default="{ item }">
                 
                   <Wall1View v-if="item.cont_type == 1" :content="item"  />
                   <Wall2View v-if="item.cont_type == 2" :content="item"  />
                   <Wall3View v-if="item.cont_type == 3" :content="item"  />
                   <Wall4View v-if="item.cont_type == 4" :content="item"  />
                   <Wall5View v-if="item.cont_type == 5" :content="item"  />
                   <Wall6View v-if="item.cont_type == 6" :content="item"  />
                   <Wall7View v-if="item.cont_type == 7" :content="item"  />
                    </template>
                  </masonry-wall>
                  </v-col>
    </v-row>

    <!-- Dialog für gefilterten Content -->
    <v-dialog v-model="dialogVisible" max-width="1400" scrollable>
      <v-card>
        <v-card-title class="headline">
    
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogVisible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 80vh;">
          <div v-if="filteredContent.length === 0">
            <p>Keine Inhalte für diese Kategorie gefunden.</p>
          </div>
          <div v-else>
            <masonry-wall :items="filteredContent" :ssr-columns="1" :column-width="320" :gap="16">
              <template #default="{ item }">
                <Wall1View v-if="item.cont_type == 1" :content="item" />
                <Wall2View v-if="item.cont_type == 2" :content="item" />
                <Wall3View v-if="item.cont_type == 3" :content="item" />
                <Wall4View v-if="item.cont_type == 4" :content="item" />
                <Wall5View v-if="item.cont_type == 5" :content="item" />
                <Wall6View v-if="item.cont_type == 6" :content="item" />
                <Wall7View v-if="item.cont_type == 7" :content="item" />
              </template>
            </masonry-wall>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>

import RegisterView from '@/components/objects/user/RegisterView.vue'
import Wall1View from '@/components/sites/objects/wall/Wall1View.vue'
import Wall2View from '@/components/sites/objects/wall/Wall2View.vue'
import Wall3View from '@/components/sites/objects/wall/Wall3View.vue'
import Wall4View from '@/components/sites/objects/wall/Wall4View.vue'
import Wall5View from '@/components/sites/objects/wall/Wall5View.vue'
import Wall6View from '@/components/sites/objects/wall/Wall6View.vue'
import Wall7View from '@/components/sites/objects/wall/Wall7View.vue'
import RowBestellung from '@/components/sites/objects/RowBestellung.vue'
import RowPraxiswissen from '@/components/sites/objects/RowPraxiswissen.vue'
import RowWebinar from '@/components/sites/objects/RowWebinar.vue'
import MasonryWall from '@yeger/vue-masonry-wall'
import { inject, onMounted, onUnmounted, ref, computed, watch } from 'vue'
import { storeToRefs } from 'pinia';
import { useBaseStore } from '@/stores/baseStore';
const baseCalls = inject('baseCalls')

const userStore = inject('userStore')
const { userData } = storeToRefs(userStore);
const baseStore = useBaseStore()
const { waizmannTableTiles, isDesktop } = storeToRefs(baseStore)
const updateDocumentHead = inject('updateDocumentHead');
const content = ref([])
const contentall = ref([])
const upcomingWebinarGroups = ref([])

function getDozentDescFromRow(row) {
  const raw = row?.dozent_desc
  if (!raw || !String(raw).trim()) {
    return ''
  }
  return String(raw).trim()
}

function getDozentImageFromRow(row) {
  const raw = row?.dozent_image
  if (!raw || !String(raw).trim()) {
    return ''
  }
  const value = String(raw).trim()
  if (value.startsWith('http://') || value.startsWith('https://') || value.startsWith('/')) {
    return value
  }

  // DB often stores only file names (e.g. "elstner.jpg").
  // Resolve those against src/assets/site for webpack bundling.
  const normalized = value
    .replace(/^\.?\//, '')
    .replace(/^assets\/site\//, '')
    .replace(/^site\//, '')

  try {
    return require('@/assets/site/' + normalized)
  } catch (err) {
    console.log('Dozentenbild konnte nicht aufgelöst werden:', value, err)
    return ''
  }
}

function toDateSortValue(webinar) {
  const parsed = Date.parse(webinar?.wter_beginn || '')
  if (!Number.isNaN(parsed)) {
    return parsed
  }
  return Number(webinar?.wter_id || 0)
}

async function getContent() {
  let data = {
    action: 'getcontenthome',
    id: 0
  }
  const response = await baseCalls.mixedGet(data)
  if (response.data.content) {
    content.value = response.data.content
  }
}


async function getContentAll() {
  let data = {
    action: 'getcontenthomeAll',
    id: 0
  }
  const response = await baseCalls.mixedGet(data)
  if (response.data.content) {
    contentall.value = response.data.content
  }
}

async function getUpcomingWebinarPreview() {
  const data = {
    action: 'getallwebinare',
    id: 0
  }

  try {
    const response = await baseCalls.webinareGet(data)
    const allWebinare = response?.data?.webinare

    if (!Array.isArray(allWebinare) || allWebinare.length === 0) {
      upcomingWebinarGroups.value = []
      return
    }

    // Prefer active webinars; fallback to all entries.
    const activeWebinare = allWebinare.filter(item => Number(item.status) === 1)
    const source = activeWebinare.length > 0 ? activeWebinare : allWebinare

    const grouped = source
      .filter(item => Number(item.wter_webinar_id || 0) > 0)
      .reduce((acc, item) => {
        const webinarId = Number(item.wter_webinar_id)
        if (!acc[webinarId]) {
          acc[webinarId] = []
        }
        acc[webinarId].push(item)
        return acc
      }, {})

    const groups = Object.entries(grouped)
      .map(([id, terms]) => {
        const sortedTerms = [...terms].sort((a, b) => toDateSortValue(a) - toDateSortValue(b))
        const preview = sortedTerms[0]
        return {
          webinarId: Number(id),
          preview,
          terms: sortedTerms,
          dozentImage: getDozentImageFromRow(preview),
          dozentDesc: getDozentDescFromRow(preview)
        }
      })
      .sort((a, b) => toDateSortValue(a.preview) - toDateSortValue(b.preview))

    upcomingWebinarGroups.value = groups
  } catch (err) {
    console.log(err)
    upcomingWebinarGroups.value = []
  }
}

// Service 
onMounted(() => {
  setTimeout(() => {
    getContent()
    getContentAll()
    getUpcomingWebinarPreview()
  }, 500);
  
  updateDocumentHead(
    "TeamWaizmann - Zahnzusatzversicherung Service der WaizmannTabelle für Zahnärzte & ZFA",
    "TeamWaizmann - Zahnzusatzversicherung Service der WaizmannTabelle für Zahnärzte & ZFA"
  );
});

const dialogVisible = ref(false)
const dialogType = ref(1)

const filteredContent = computed(() => {
  let allowedTypes = []
  
  switch (dialogType.value) {
    case 1: // WaizmannTabellen
      allowedTypes = [1, 3]
      break
    case 2: // YouTube & Co
      allowedTypes = [7]
      break
    case 3: // Webinare
      allowedTypes = [2]
      break
    case 4: // Praxiswissen
      allowedTypes = [6]
      break
    default:
      allowedTypes = [dialogType.value]
  }
  
  return contentall.value.filter(item => allowedTypes.includes(item.cont_type))
})

const wall5Index = ref(0)
const wall5Items = computed(() =>
  contentall.value.filter(item => item.cont_type == 5 && item.cont_image)
)
const wall5ImageSrc = computed(() => {
  const item = wall5Items.value[wall5Index.value]
  return item ? require('@/assets/wallaufsteller/' + item.cont_image) : ''
})

let wall5Timer = null
const ROTATION_MS = 4000

const startWall5Rotation = () => {
  if (wall5Timer) {
    clearInterval(wall5Timer)
    wall5Timer = null
  }
  if (wall5Items.value.length > 1) {
    wall5Timer = setInterval(() => {
      wall5Index.value = (wall5Index.value + 1) % wall5Items.value.length
    }, ROTATION_MS)
  }
}

watch(wall5Items, () => {
  wall5Index.value = 0
  startWall5Rotation()
}, { immediate: true })

onUnmounted(() => {
  if (wall5Timer) {
    clearInterval(wall5Timer)
  }
})

</script>

<style scoped>
.home-hero {
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: none;
  border-radius: 0;
  background: transparent;
  padding: 0;
}

.home-hero__title {
  font-size: 24px;
  font-weight: 800;
  color: #1f3a63;
}

.home-hero__subtitle {
  font-size: 16px;
  color: #4a5568;
  margin-top: -8px;
  margin-bottom: 16px;
}

.home-hero__body {
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 1fr);
  gap: 24px;
  align-items: stretch;
}

.home-hero__body--stack {
  grid-template-columns: 1fr;
}

.home-hero__tiles {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
}

.home-hero__tile {
  aspect-ratio: 105 / 168;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  color: #ffffff;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.home-hero__tile-title {
  font-size: 16px;
  line-height: 1.1;
  text-align: right;
}

.home-hero__tile-sub {
  font-size: 16px;
  opacity: 1;
  font-weight: 900;
  letter-spacing: 0.4px;
  text-align: right;
  align-self: flex-end;
  background: rgba(255, 255, 255, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.35);
  padding: 4px 8px;
  border-radius: 4px;
}

.home-hero__tile--blue {
  background: #3166a5;
}

.home-hero__tile--pink {
  background: #e24b8a;
}

.home-hero__tile--gray {
  background: #9aa3af;
}

.home-hero__media {
  align-self: stretch;
  aspect-ratio: 105 / 162;
  display: flex;
  align-items: stretch;
  width: 100%;
  margin-top: 0;
}

.home-hero__image {
  width: 90%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 4px;
  background: #f7f9fc;
  border: 1px solid #e5edf4;
}

.home-hero--mobile .home-hero__tiles {
  grid-template-columns: 1fr;
}

.home-hero--mobile .home-hero__title {
  font-size: 18px;
}

.home-hero--mobile .home-hero__tile {
  padding: 10px;
  aspect-ratio: 105 / 150;
}

.home-hero--mobile .home-hero__tile-title {
  font-size: 14px;
}

.home-hero--mobile .home-hero__tile-sub {
  font-size: 13px;
  padding: 3px 6px;
}

.home-hero--mobile .home-hero__image {
  width: 100%;
}

.home-hero--mobile .home-hero__media {
  max-width: 100%;
}

@media (max-width: 960px) {
  .home-hero {
    flex-direction: column;
  }

  .home-hero__body {
    flex-direction: column;
  }

  .home-hero__tiles {
    grid-template-columns: 1fr;
    max-width: 100%;
  }

  .home-hero__media {
    width: 100%;
    max-width: 100%;
  }
}

.home-quick-card {
  border: 1px solid #e5edf4;
  border-radius: 4px;
  background: #ffffff;
  padding: 16px;
}

.home-quick-card__title {
  font-size: 18px;
  font-weight: 800;
  color: #1f3a63;
}

.home-quick-card__items {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.home-quick-card__item {
  aspect-ratio: 105 / 168;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: #ffffff;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.home-quick-card__item-title {
  font-size: 12px;
  line-height: 1.1;
}

.home-quick-card__item-sub {
  font-size: 11px;
  opacity: 0.9;
}

.home-quick-card__item--blue {
  background: #3166a5;
}

.home-quick-card__item--pink {
  background: #e24b8a;
}

.home-quick-card__item--gray {
  background: #9aa3af;
}

.home-next-webinar__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.home-next-webinar__title {
  margin: 0;
  color: #1f3a63;
}

.home-next-webinar__link {
  color: #3166a5;
  font-weight: 600;
  text-decoration: none;
}

.home-next-webinar__empty {
  margin: 0;
  color: #4a5568;
}

.home-next-webinar__list {
  display: grid;
  gap: 16px;
}

.home-next-webinar__item {
  border: 1px solid #e1e6ef;
  border-radius: 10px;
  padding: 14px;
  background: #ffffff;
}

.home-next-webinar__item-head {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.home-next-webinar__preview {
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 16px;
  align-items: start;
  border: 1px solid #e1e6ef;
  border-radius: 10px;
  background: #f7f9fc;
  padding: 14px;
}

.home-next-webinar__photo {
  width: 160px;
  height: 180px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #d7deea;
  background: #fff;
}

.home-next-webinar__eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  color: #6b7a99;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 700;
}

.home-next-webinar__webinar-title {
  margin: 0 0 8px;
  color: #1f3a63;
}

.home-next-webinar__dozent {
  margin: 0 0 8px;
  font-weight: 600;
  color: #1f3a63;
}

.home-next-webinar__desc {
  margin: 0;
  color: #4a5568;
  white-space: pre-line;
}

.home-next-webinar__termine {
  margin-top: 12px;
}

.home-next-webinar__termine-title {
  margin: 0 0 8px;
  color: #1f3a63;
  font-size: 16px;
}

.home-next-webinar__termine-list {
  margin: 0;
  padding-left: 18px;
  color: #4a5568;
  font-size: 14px;
}

.home-next-webinar__termine-list li {
  margin-bottom: 4px;
}

.home-next-webinar__status {
  color: #6b7a99;
}

.home-next-webinar__cta {
  text-transform: none;
}

@media (max-width: 760px) {
  .home-next-webinar__preview {
    grid-template-columns: 1fr;
  }
}
</style>
